export default function checkIfUrlIsSourceLink(loc: Pick<Location, 'pathname' | 'search'>, disableSeoRoutes: boolean, searchPath: string): string {
    // Here for old compatibility -> Zeilinger
    const checkMagicId = (disableSeoRoutes === true ? location?.search?.match(/[?&]magicId=([0-9]+)/) : loc?.pathname?.match(/\/magicId\/([0-9]+)/))?.[1];
    const checkSource = (disableSeoRoutes === true ? location?.search?.match(/[?&]source=([0-9]+)/) : loc?.pathname?.match(/\/source\/([0-9]+)/))?.[1];
    const checkOldEinzelansicht = (disableSeoRoutes === true ? undefined : loc?.search?.match(/_carId([0-9]+)/))?.[1];
    const pathnameOldNew = loc?.pathname?.replace(searchPath, '');
    const checkOldNewEinzelansicht = disableSeoRoutes === true || loc?.pathname?.startsWith('/c/') ? undefined : pathnameOldNew?.match(/\/[A-z0-9-]+/g)?.[5]?.replace('/', '');

    return checkMagicId || checkSource || checkOldEinzelansicht || checkOldNewEinzelansicht;
}
